// Environment variables configuration
export const env = {
  apiUrl: import.meta.env.VITE_API_URL,
  internalSystemToken: import.meta.env.VITE_INTERNAL_SYSTEM_TOKEN as string,
  environment: import.meta.env.MODE || 'development',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;
